var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 528,
    height: 621,
    viewBox: "0 0 528 621",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 473,
    height: 580
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M456.557 206.715C462.696 206.65 468.279 210.182 470.849 215.669C473.633 221.613 472.765 228.138 469.229 232.563L196.949 573.23C195.073 575.212 193.442 576.521 191.141 577.594C186.533 579.732 181.531 579.828 177.052 577.452C170.549 574.347 166.446 566.788 168.483 559.164L217.488 371.658L15.8509 372.277C9.71169 372.342 4.13009 368.81 1.55932 363.324C-1.01141 357.837 -0.357077 350.854 3.17904 346.43L275.673 6.22124C280.163 0.241139 288.178 -1.80828 294.896 1.75394C301.859 4.64513 305.501 12.4177 303.925 19.8287L254.92 207.335L456.557 206.715Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.694 205.006C462.783 204.941 468.317 208.445 470.867 213.885C473.628 219.78 472.768 226.252 469.26 230.639L199.231 568.488C197.373 570.455 195.756 571.753 193.473 572.817C188.903 574.937 183.941 575.032 179.5 572.677C173.05 569.597 168.982 562.101 171.002 554.539L219.601 368.584L19.6324 369.198C13.544 369.264 8.00859 365.76 5.45908 360.318C2.90961 354.878 3.55854 347.952 7.06541 343.564L277.307 6.16979C281.759 0.239145 289.707 -1.79332 296.369 1.73944C303.275 4.6067 306.886 12.3151 305.324 19.6646L256.724 205.621L456.694 205.006Z",
    fill: "#01FFC8"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_11_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 508,
    height: 602
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M457.301 213.303C463.44 213.236 511.632 239.077 514.205 244.562C516.986 250.507 516.118 257.033 512.582 261.457L240.302 602.123C238.426 604.106 236.796 605.414 234.494 606.487C229.887 608.627 224.883 608.721 220.406 606.346C213.902 603.241 173.672 570.399 175.708 562.775L263.41 420.543H72.4149C66.2758 420.608 5.31681 361.973 8.85292 357.55C136.478 194.336 227.593 78.6411 282.197 10.4673C291.122 -0.674789 331.531 27.0857 338.249 30.6479C345.213 33.5391 348.854 41.3117 347.278 48.7226L298.273 236.228L457.301 213.303Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_11_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M457.301 213.303C463.44 213.236 511.632 239.077 514.205 244.562C516.986 250.507 516.118 257.033 512.582 261.457L240.302 602.123C238.426 604.106 236.796 605.414 234.494 606.487C229.887 608.627 224.883 608.721 220.406 606.346C213.902 603.241 173.672 570.399 175.708 562.775L263.41 420.543H72.4149C66.2758 420.608 5.31681 361.973 8.85292 357.55C136.478 194.336 227.593 78.6411 282.197 10.4673C291.122 -0.674788 331.531 27.0857 338.249 30.6479C345.213 33.5391 348.854 41.3117 347.278 48.7227L298.273 236.228L457.301 213.303Z",
    stroke: "#01FFC8",
    strokeWidth: 0.930593
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.f8ca646ed3eda82ce06153230c737ecc.svg";
export { ForwardRef as ReactComponent };